import { SVGProps } from '@commenda/icons/types';
import { Badge, Icons } from '@commenda/kakashi';
import { cn } from '@commenda/utils';

interface ActionItemProps {
  id?: number;
  Icon: (props: SVGProps) => JSX.Element;
  title: string;
  count: number;
  overdue?: number;
  description: string;
  _className: string;
  gotoUrl: string;
  handleOnClick: (string) => void;
  badgeText?: string;
  hideDot?: boolean;
}

const ActionItem = ({
  Icon,
  title,
  count,
  overdue,
  description,
  handleOnClick,
  gotoUrl,
  _className,
  badgeText,
  hideDot,
}: ActionItemProps) => {
  return (
    <div
      className="flex items-center py-5 px-5 bg-bg-primary hover:bg-bg-primary-hover rounded-lg mb-3 border cursor-pointer"
      onClick={() => handleOnClick(gotoUrl)}
    >
      <div
        className={cn(
          `w-16 h-16 flex items-center justify-center rounded-lg mr-4 border`,
          _className
        )}
      >
        <Icon />
      </div>
      <div className="flex-grow">
        <div className="flex items-center">
          <h3 className="txt-medium-medium text-text-primary">{title}</h3>
          {!hideDot ? (
            <span className="ml-2 txt-medium-bold text-text-primary">
              · {count}
            </span>
          ) : null}
          {badgeText ? (
            <Badge
              size="sm"
              variant="warning"
              className="ml-3 txt-extra-small-medium"
            >
              {badgeText}
            </Badge>
          ) : null}
          {overdue && (
            <Badge
              size="sm"
              variant="error"
              className="ml-3 txt-extra-small-medium"
            >
              {overdue} overdue
            </Badge>
          )}
        </div>
        <p className="txt-small-regular text-text-tertiary mt-2">
          {description}
        </p>
      </div>
      <Icons.ArrowNarrowRight className="w-5 h-5 text-neutral-4" />
    </div>
  );
};

export { ActionItem };
export type { ActionItemProps };
